import React from "react";

function BottomComponent() {
  return (
    <div
      style={{
        maxWidth: "100%",
        textAlign: "center",
        padding: "20px",
        background: "rgb(255,255,255)",
        color: "grey",
      }}
    >
      <h5>Muhammad Daffa Aththarriq | Final Project React JS | 2020</h5>
    </div>
  );
}

export default BottomComponent;
